/* @flow @format */

import { from, throwError } from 'rxjs';
import { mergeMap, switchMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import type { ActionType } from '../utils';
import type { ObservableAction } from './types';
import { catchWith, getData } from './utils';
import { fetchRankingsSuccess } from '../reducer/ranking';
import { finishActivityBegin, finishActivityFailure, finishActivitySuccess } from '../reducer/activity';
import Sentry from '../../../sentry';
import api from '../../graphql/api';

export function finishActivityEpic(action$: ObservableAction): ObservableAction {
  return action$.pipe(
    ofType<ActionType<typeof finishActivityBegin>>(finishActivityBegin.type),
    switchMap(({ payload }) =>
      from(api.finishActivity(payload)).pipe(
        getData(),
        mergeMap(({ examineeActivityFinish }) => {
          if (examineeActivityFinish.__typename === 'ExamineeActivityFinishFailure') {
            Sentry.captureMessage("Can't finish activity, maybe duplicate session");
            return throwError(new Error('Finish failure'));
          }
          const { isNewHighScore, scoring } = examineeActivityFinish;
          return from([
            fetchRankingsSuccess({ uid: payload.courseContentUid, scoring, isNewHighScore }),
            finishActivitySuccess(),
          ]);
        }),
        catchWith(finishActivityFailure, payload)
      )
    )
  );
}

export default finishActivityEpic;
